export const SIGN_IN = '/signin';
export const LANDING = '/';
export const HOME = '/home';
export const PROFILE = '/profile';
export const PASSWORD_FORGET = '/pw-forget';


// WEBPACK FOOTER //
// ./src/Constants/routes.js